module.exports = __webpack_public_path__ + "static/img/ksrk_logo1.8bea634.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/官网首页/firstlink/ksrk_logo1.png
// module id = WMV8
// module chunks = 1